import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, LinkedinIcon, TwitterIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-surface border-t-2 border-gold pt-20 pb-10" data-id="element-37">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-38">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-39">
          {/* Brand */}
          <div data-id="element-40">
            <Link to="/" className="text-gold font-heading text-2xl font-bold tracking-[0.2em] uppercase block mb-6" data-id="element-41">
              BioShift
            </Link>
            <p className="text-muted text-sm leading-relaxed mb-6" data-id="element-42">
              Human performance and longevity company helping high-performing
              professionals restore metabolic health and reclaim control of
              their lives.
            </p>
            <div className="flex space-x-4" data-id="element-43">
              <a href="https://www.instagram.com/elisachiaradia3/" target="_blank" rel="noopener noreferrer" className="text-muted hover:text-gold transition-colors" aria-label="Instagram" data-id="element-44">
                <InstagramIcon className="w-5 h-5" data-id="element-45" />
              </a>
              <a href="https://www.linkedin.com/in/elisa-chiaradia-1a0715280/" target="_blank" rel="noopener noreferrer" className="text-muted hover:text-gold transition-colors" aria-label="LinkedIn" data-id="element-46">
                <LinkedinIcon className="w-5 h-5" data-id="element-47" />
              </a>
              <a href="#" className="text-muted hover:text-gold transition-colors" aria-label="Twitter" data-id="element-48">
                <TwitterIcon className="w-5 h-5" data-id="element-49" />
              </a>
            </div>
          </div>

          {/* Company */}
          <div data-id="element-50">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-51">
              Company
            </h4>
            <ul className="space-y-4" data-id="element-52">
              <li data-id="element-53">
                <Link to="/about" className="text-muted hover:text-gold transition-colors text-sm" data-id="element-54">
                  About Us
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/programs" className="text-muted hover:text-gold transition-colors text-sm" data-id="element-56">
                  All Programs
                </Link>
              </li>
              <li data-id="element-57">
                <Link to="/testimonials" className="text-muted hover:text-gold transition-colors text-sm" data-id="element-58">
                  Testimonials
                </Link>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div data-id="element-59">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-60">
              Programs
            </h4>
            <ul className="space-y-4" data-id="element-61">
              <li data-id="element-62">
                <Link to="/programs/longevity" className="text-muted hover:text-gold transition-colors text-sm" data-id="element-63">
                  Longevity Program
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/programs/corporate-wellness" className="text-muted hover:text-gold transition-colors text-sm" data-id="element-65">
                  Corporate Wellness
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/programs/faith-fitness" className="text-muted hover:text-gold transition-colors text-sm" data-id="element-67">
                  Faith & Fitness
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources & Connect */}
          <div data-id="element-68">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-69">
              Connect
            </h4>
            <ul className="space-y-4" data-id="element-70">
              <li data-id="element-71">
                <Link to="/blog" className="text-muted hover:text-gold transition-colors text-sm" data-id="element-72">
                  Insights & Blog
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/contact" className="text-muted hover:text-gold transition-colors text-sm" data-id="element-74">
                  Contact Us
                </Link>
              </li>
              <li className="flex items-center text-sm mt-4" data-id="element-75">
                <MailIcon className="w-4 h-4 mr-2 text-gold" data-id="element-76" />
                <a href="mailto:elisa@bioshift.net" className="text-muted hover:text-gold transition-colors" data-id="element-77">
                  elisa@bioshift.net
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-78">
          <p className="text-muted text-sm mb-4 md:mb-0" data-id="element-79">
            &copy; {new Date().getFullYear()} BioShift. All rights reserved.
          </p>
          <p className="text-muted text-sm" data-id="element-80">
            Dallas, Texas | Nationwide Online Coaching
          </p>
        </div>
      </div>
    </footer>;
}